import { render } from "./DrivePhotoCarousel.vue?vue&type=template&id=530abe91&scoped=true&ts=true"
import script from "./DrivePhotoCarousel.vue?vue&type=script&lang=ts"
export * from "./DrivePhotoCarousel.vue?vue&type=script&lang=ts"

import "./DrivePhotoCarousel.vue?vue&type=style&index=0&id=530abe91&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530abe91"]])

export default __exports__